module.exports = __webpack_public_path__ + "img/ic_check_layer5.2c92983e.png";